import { useEffect, useState } from "react";
import { Table, Badge } from "reactstrap";
import TableHeader from "../../common/tableHeader";
import TableLoader from "../../common/tableLoader";
import Popup from "../../common/popup";
import NoRecordsFound from "../../common/noRecordsFound";

const LowActivityUsersDetail = ({
    isLoading,
    userList,
    getUsers,
    deleteUser,
    deleteId,
    removeSuccess,
    setSortBy,
    sortBy,
    setSortOrder,
    sortOrder,
}) => {


    const [toggleModal, setToggleModal] = useState(false);

    useEffect(() => {
        if (removeSuccess) {
            setToggleModal(false);
            getUsers();
        }
    }, [removeSuccess]);


    const sortData = (title) => {
        setSortBy(title)
        setSortOrder(sortOrder === 1 ? -1 : 1)
    }

    return (
        <>
            <Table responsive striped bordered hover size="sm" className="shadow">
                <TableHeader
                    headers={[
                        { title: "Name", showIcon: true },
                        { title: "Email", showIcon: true },
                        { title: "Phone", showIcon: true },
                        { title: "Company", showIcon: true },
                        { title: "Verified", showIcon: true },
                    
                    ]}
                    sortData={sortData}
                    setSortBy={setSortBy}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                />
                <tbody>
                    {isLoading ? (
                        <TableLoader colSpan="8" />
                    ) : (
                        <>
                            {userList && userList.length > 0 ? (
                                userList?.map((item, idx) => {
                                    return (
                                        <tr id={idx} style={{ whiteSpace: "nowrap" }}>
                                            <td>

                                                <span>{item?.name} </span>

                                            </td>
                                            <td>{item?.email}</td>
                                            <td>{item?.phone}</td>
                                            <td>{item?.company}</td>
                                            <td>
                                                {item?.verified === "n" ? (
                                                    <Badge color="danger">Not Verified</Badge>
                                                ) : (
                                                    <Badge color="success">Verified</Badge>
                                                )}
                                            </td>

                                        </tr>
                                    );
                                })
                            ) : (
                                <NoRecordsFound colSpan={"8"} />
                            )}
                        </>
                    )}
                </tbody>
            </Table>
            {toggleModal && (
                <Popup
                    showPopup={toggleModal}
                    hidePopup={() => setToggleModal(false)}
                    actionMethod={() => deleteUser(deleteId)}
                    title="Delete User"
                    promtMessage="Are you sure you want to delete User?"
                />
            )}
        </>
    );
}
export default LowActivityUsersDetail